import { useState, useEffect } from 'react';
import { getAuraBadge, calculateAuraStats } from '../utils/aura';

const GOOD_CATEGORIES = [
  { name: 'Drip King', emoji: '👑', icon: '/dripkingicon.png' },
  { name: 'Drip Queen', emoji: '👸', icon: '/dripqueenicon.png' },
  { name: "Bussin'", emoji: '✨', icon: '/bussinicon.png' },
  { name: 'Fire Fit', emoji: '🔥', icon: '/firefiticon.png' },
];

const BAD_CATEGORIES = [
  { name: 'Mid', emoji: '😐', icon: '/midicon.png' },
  { name: 'Ohio', emoji: '🌽', icon: '/ohioicon.png' },
  { name: 'Cringe', emoji: '😬', icon: '/cringeicon.png' },
  { name: 'Cooked', emoji: '💀', icon: '/cookedicon.png' },
];

function Landing({ topAvatars, onNavigate, onOpenLogin }) {
  // Extract top 3 avatars (order: 1st, 2nd, 3rd)
  const first = topAvatars[0];
  const second = topAvatars[1];
  const third = topAvatars[2];

  return (
    <div className="landing-container">
      {/* Hero Section with Podium */}
      <div className="hero-section">
        <div className="hero-content">
          {/* Title Above Podium */}
          <div className="hero-title-section">
            <img
              src="/logo.png"
              alt="Drip Battle Logo"
              className="hero-logo-image"
            />
            <p className="hero-subtitle">Where Roblox Drip Gets Judged 🔥</p>
          </div>

          {/* Podium Section */}
          {topAvatars.length > 0 && (
            <div className="podium-container">
              {/* 2nd Place - Left */}
              {second && (
                <div className="podium-spot second-place" onClick={() => onNavigate('profile', second.username)} style={{ cursor: 'pointer' }}>
                  <div className="podium-avatar-wrapper">
                    <img
                      src={second.avatarUrl}
                      alt={second.username}
                      className="podium-avatar"
                    />
                    {(() => {
                      const auraStats = calculateAuraStats(
                        second.auraStats?.fireSwipes || 0,
                        second.auraStats?.leftSwipes || 0
                      );
                      const auraBadge = getAuraBadge(auraStats.auraPercent, auraStats.totalSwipes);
                      return (
                        <div className="aura-badge-overlay">
                          <img src={auraBadge.emoji} alt={auraBadge.label} className="aura-badge-image" />
                        </div>
                      );
                    })()}
                  </div>
                  <div className="podium-info">
                    <div className="podium-crown">
                      {second.topCategoryLabel?.icon ? (
                        <img src={second.topCategoryLabel.icon} alt={second.topCategoryLabel.name} className="category-icon" />
                      ) : (
                        second.topCategoryLabel?.emoji || '👸'
                      )}
                    </div>
                    <div className="podium-username">{second.username}</div>
                    <div className="podium-votes">{second.totalVotes} votes</div>
                  </div>
                  <div className="podium-base silver-base">
                    <div className="base-label">{second.topCategoryLabel?.name || 'Top Drip'}</div>
                  </div>
                </div>
              )}

              {/* 1st Place - Center */}
              {first && (
                <div className="podium-spot first-place" onClick={() => onNavigate('profile', first.username)} style={{ cursor: 'pointer' }}>
                  <div className="podium-avatar-wrapper">
                    <img
                      src={first.avatarUrl}
                      alt={first.username}
                      className="podium-avatar"
                    />
                    {(() => {
                      const auraStats = calculateAuraStats(
                        first.auraStats?.fireSwipes || 0,
                        first.auraStats?.leftSwipes || 0
                      );
                      const auraBadge = getAuraBadge(auraStats.auraPercent, auraStats.totalSwipes);
                      return (
                        <div className="aura-badge-overlay">
                          <img src={auraBadge.emoji} alt={auraBadge.label} className="aura-badge-image" />
                        </div>
                      );
                    })()}
                  </div>
                  <div className="podium-info">
                    <div className="podium-crown champion">
                      {first.topCategoryLabel?.icon ? (
                        <img src={first.topCategoryLabel.icon} alt={first.topCategoryLabel.name} className="category-icon" />
                      ) : (
                        first.topCategoryLabel?.emoji || '👑'
                      )}
                    </div>
                    <div className="podium-username champion">{first.username}</div>
                    <div className="podium-votes">{first.totalVotes} votes</div>
                  </div>
                  <div className="podium-base gold-base">
                    <div className="base-label">{first.topCategoryLabel?.name || 'Top Drip'}</div>
                  </div>
                </div>
              )}

              {/* 3rd Place - Right */}
              {third && (
                <div className="podium-spot third-place" onClick={() => onNavigate('profile', third.username)} style={{ cursor: 'pointer' }}>
                  <div className="podium-avatar-wrapper">
                    <img
                      src={third.avatarUrl}
                      alt={third.username}
                      className="podium-avatar"
                    />
                    {(() => {
                      const auraStats = calculateAuraStats(
                        third.auraStats?.fireSwipes || 0,
                        third.auraStats?.leftSwipes || 0
                      );
                      const auraBadge = getAuraBadge(auraStats.auraPercent, auraStats.totalSwipes);
                      return (
                        <div className="aura-badge-overlay">
                          <img src={auraBadge.emoji} alt={auraBadge.label} className="aura-badge-image" />
                        </div>
                      );
                    })()}
                  </div>
                  <div className="podium-info">
                    <div className="podium-crown">
                      {third.topCategoryLabel?.icon ? (
                        <img src={third.topCategoryLabel.icon} alt={third.topCategoryLabel.name} className="category-icon" />
                      ) : (
                        third.topCategoryLabel?.emoji || '🏆'
                      )}
                    </div>
                    <div className="podium-username">{third.username}</div>
                    <div className="podium-votes">{third.totalVotes} votes</div>
                  </div>
                  <div className="podium-base bronze-base">
                    <div className="base-label">{third.topCategoryLabel?.name || 'Top Drip'}</div>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* CTA Buttons */}
          <div className="hero-actions">
            <button
              className="cta-button primary"
              onClick={onOpenLogin}
            >
              🔑 Login / Sign Up
            </button>
            <button
              className="cta-button secondary"
              onClick={() => onNavigate('vote')}
            >
              🔥 Start Voting
            </button>
            <button
              className="cta-button tertiary"
              onClick={() => onNavigate('aura')}
            >
              ⚡ Aura Farming
            </button>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="features-section">
        <h2 className="section-title">How It Works</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">📸</div>
            <h3>Submit Your Drip</h3>
            <p>Enter your Roblox username and let the community judge your outfit</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🔥</div>
            <h3>Vote & Earn</h3>
            <p>Rate avatars and earn Lit-Bits to vote on more drip</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">⚡</div>
            <h3>Build Your Aura</h3>
            <p>Swipe to farm aura and climb to the top of the leaderboard</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🏆</div>
            <h3>Become Champion</h3>
            <p>Compete to become Drip King or Drip Queen</p>
          </div>
        </div>
      </div>

      {/* Categories Preview */}
      <div className="categories-section">
        <h2 className="section-title">Vote Categories</h2>
        <div className="categories-preview">
          <div className="category-row good-categories">
            <h3>🔥 Good Vibes</h3>
            <div className="category-badges">
              {GOOD_CATEGORIES.map((category, index) => (
                <div key={index} className="category-badge good">
                  {category.icon ? (
                    <img src={category.icon} alt={category.name} className="category-icon" />
                  ) : (
                    category.emoji
                  )} {category.name}
                </div>
              ))}
            </div>
          </div>
          <div className="category-row bad-categories">
            <h3>💀 L Energy</h3>
            <div className="category-badges">
              {BAD_CATEGORIES.map((category, index) => (
                <div key={index} className="category-badge bad">
                  {category.icon ? (
                    <img src={category.icon} alt={category.name} className="category-icon" />
                  ) : (
                    category.emoji
                  )} {category.name}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Landing;
